import React from "react";
import { m } from "framer-motion";
import { twMerge } from "tailwind-merge";

export default function PlaygroundArea({ name = "", children, ...props }) {
  if (!name) return false;
  return (
    <m.div {...props} className={twMerge(`${name}-area`, props?.className)}>
      {children}
    </m.div>
  );
}
